import { defineComponent as _defineComponent } from 'vue'
import { addPlankToStore } from '@/apis/bujianStore'
import { deleteStoreData } from '@/apis/bujianStore'
import { LibraryType } from '@/apis/bujianStore/types'
import { buryPoint } from '@/apis/common/buryPoint'
import GBaseModal from '@/components/g-base-modal.vue'
import GBujianTable from '@/components/g-bujian-table.vue'
import { PartType } from '@/partTypes'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi, genFinalRecord } from '@/util/commonFuncs'
import { operateRecordTableType } from '@/util/configure'
import { getPlankToAwaitStoreData } from '@/views/newPaiban/component/m-paiban-store/utlis'
import { message } from 'ant-design-vue'
import moment from 'moment'
import { computed, ref, watch } from 'vue'

import { pickerOptions, searchTypeList } from './data'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const activeKey = ref('store')
const isShowDialog = ref(false)
const isShowSaveToAwaitStoreDialog = ref(false)
const isAddAwaitStoreLoading = ref(false)

const isStore = computed(
  () => search.value.library_type === LibraryType.bujianStore
)
const isAwaitStore = computed(
  () => search.value.library_type === LibraryType.awaitStore
)
const isLoading = ref(false)

const bujianStoreRef = ref<InstanceType<typeof GBujianTable>>()
const awaitStoreRef = ref<InstanceType<typeof GBujianTable>>()

const paibanData = ref<PartType[]>([])
const needToAwaitPlanks = ref<PartType[]>([])
const selectIds = ref<number[]>([])

const timer = [
  moment().subtract(1, 'month').format('YYYY-MM-DD'),
  moment().format('YYYY-MM-DD'),
]
const awaitStoreFilterTime = ref([...timer])
const bujianStoreFilterTime = ref([...timer])

const filterTime = ref([...timer])

const search = ref({
  searchType: '1',
  searchKey: '',
  library_type: 1 as 1 | 2,
  filterTime: [] as string[],
})

const selectOption = ref(searchTypeList[0])

watch(
  () => search.value.searchType,
  (val) => {
    selectOption.value = searchTypeList.find((item) => item.value === val)!
  }
)

/** 补件翻译函数 */
function t(k: string, val?: any) {
  return translate('bujianAndStore.' + k, val)
}

/** 公共的翻译函数 */
function ct(k: string, val?: any) {
  return translate('common.' + k, val)
}

/** 调用子组件内部的批量删除 */
function handleBatchDelete() {
  isStore.value && bujianStoreRef.value?.handleStoreBatchDelete()
  isAwaitStore.value && awaitStoreRef.value?.handleStoreBatchDelete()
  buryPoint({
    function_module: 'await_store',
    function_point: 'batch_push_store',
  })
}

/** 单个入库 */
function handleSinglePushAwaitStore(data: any[]) {
  addPlankToAwaitStore(data)
  isShowSaveToAwaitStoreDialog.value = true
  buryPoint({
    function_module: 'await_store',
    function_point: 'single_push_store',
  })
}

/** 触发搜索 */
function handleSearch() {
  const query = search.value
  query.filterTime = filterTime.value
  // 修改不同的时间查询参数
  if (isStore.value) {
    bujianStoreRef.value?.search(query)
  } else {
    awaitStoreRef.value?.search(query)
  }
  if (search.value.library_type === 1) {
    buryPointApi('supplement', 'handle_search')
  } else {
    buryPointApi('await_store', 'await_handle_search')
  }
}

/** 批量添加 */
function handleBatchAddBujianToAwaitStore() {
  const planks = bujianStoreRef.value?.getSelectData()
  if (!planks?.length) return message.warning(ct('pleaseSelectPlank'))
  addPlankToAwaitStore(planks)
  isShowSaveToAwaitStoreDialog.value = true
  buryPointApi('supplement', 'batch_add_bujian')
}

function addPlankToAwaitStore(planks: PartType[]) {
  needToAwaitPlanks.value = planks
}

const bujianRecordKeys = [
  'address',
  'customer_name',
  'plankID',
  'matCode',
  'texture',
  'sizeStr',
  'plankNum',
  'create_time',
]

/** 存入待排版库操作记录：补件库删除 + 待排版库新增 */
function savePushToAwaitStoreRecord(planks: PartType[]) {
  const recordList = planks.filter(Boolean)
  if (!recordList.length) return

  genFinalRecord(
    {
      key: '',
      operateArr: [
        {
          key: '补件库-存入待排版库',
          dataArr: [
            {
              type: 'table',
              list: [],
              oriList: recordList,
              keys: bujianRecordKeys,
              tableType: operateRecordTableType.BUJIAN_PLANK_TABLE,
              idKey: 'id',
            },
          ],
        },
        {
          key: '待排版库',
          dataArr: [
            {
              type: 'table',
              list: recordList,
              oriList: [],
              keys: bujianRecordKeys,
              tableType: operateRecordTableType.BUJIAN_PLANK_TABLE,
              idKey: 'id',
            },
          ],
        },
      ],
    },
    'supplement-management',
    -2,
    () => {
      console.log('savePushToAwaitStoreRecord', planks)
    }
  )
}

function handleStartLoading(data: any) {
  isLoading.value = data.isLoading
}

/** 选择板件进行批量排版 */
async function handleBatchPaiban() {
  const bujianPlanks = bujianStoreRef.value?.getSelectData()
  const awaitStorePlanks = awaitStoreRef.value?.getSelectData()
  if (!bujianPlanks?.length && !awaitStorePlanks?.length) {
    return message.warning(ct('pleaseSelectPlank'))
  }
  const fetchPlankData = async (plankSource: any, analyzeMethod: any) => {
    if (plankSource?.length) {
      const planks = await analyzeMethod(plankSource)
      if (!planks || (planks.status !== undefined && planks.status !== 1)) {
        return []
      }
      return planks.data?.plank_data || planks
    }
    return []
  }

  const bujianPlank = await fetchPlankData(
    bujianPlanks,
    bujianStoreRef.value?.getAnalyzeData
  )
  const awaitStorePlank = await fetchPlankData(
    awaitStorePlanks,
    awaitStoreRef.value?.getAwaitStoreAnalyzeData
  )
  // 记录当次参与排版的待排版id
  if (awaitStorePlanks) {
    awaitStoreRef.value?.recordPaibanStoreId(awaitStorePlanks)
  }
  paibanData.value = [...awaitStorePlank, ...bujianPlank]

  // 如选择了补件库和待排版库的板件数据需要询问用户是否一起排版
  if (bujianPlank.length && awaitStorePlank.length) {
    isShowDialog.value = true
    return
  }

  bujianStoreRef.value?.goToMaterialPage(paibanData.value)
}

/** 确认携带待排版库和补件库小板进行排版 */
function handleOk() {
  bujianStoreRef.value?.goToMaterialPage(paibanData.value)
  isShowDialog.value = false
}

/** 添加板件到待排版仓库 */
async function handlePushPlankToAwaitStore(planks: PartType[]) {
  try {
    isAddAwaitStoreLoading.value = true
    const layout = await bujianStoreRef.value?.getAnalyzeData(planks)
    if (!layout) return
    const plankData = layout.data.plank_data
    const data = await getPlankToAwaitStoreData(plankData, undefined, false)
    if (!data) {
      // 数据生成错误
      return message.error(t('dataGenErr'))
    }
    const result = await addPlankToStore(data)
    if (result.status !== 1) return message.error(result.msg)
    // 入库成功
    message.success(t('pushStoreSuccess'))
    savePushToAwaitStoreRecord([...planks])
    // 入库后需要删除补件的数据
    const ids = planks.map((item) => item.id)
    const news = planks.map((item: any) => (item.new ? '1' : '0'))
    await deleteStoreData({ ids: ids.join(), new: news.join() })
    handleSearch()
    buryPoint({
      function_module: 'await_store',
      function_point: 'batch_push_store',
    })
  } catch (error) {
    // 出现未知错误，入库失败
    message.error(t('unknownErr'))
  } finally {
    isAddAwaitStoreLoading.value = false
    isShowSaveToAwaitStoreDialog.value = false
  }
}

/** 切换标签页面时重置部分参数 */
function handleTabChange() {
  search.value.searchKey = ''
  search.value.searchType = '1'
  // 切换时将之前存储的参数重新复制给时间数据
  filterTime.value = isAwaitStore.value
    ? [...awaitStoreFilterTime.value]
    : [...bujianStoreFilterTime.value]
  handleSearch()
}

function handlePlankSelectChange() {
  const bujianSelect =
    bujianStoreRef.value?.getSelectData()?.map((it) => it.id) ?? []
  const awaitSelect =
    awaitStoreRef.value?.getSelectData()?.map((it) => it.id) ?? []
  selectIds.value = [...new Set([...bujianSelect, ...awaitSelect])]
}

/** 保存时间参数 */
function handleTimeChange() {
  if (isAwaitStore.value) {
    awaitStoreFilterTime.value = [...(filterTime.value ?? [])]
  } else {
    bujianStoreFilterTime.value = [...(filterTime.value ?? [])]
  }
  handleSearch()
  if (search.value.library_type === 1) {
    buryPointApi('supplement', 'time_select')
  } else {
    buryPointApi('await_store', 'await_time_select')
  }
}

return { __sfc: true,activeKey, isShowDialog, isShowSaveToAwaitStoreDialog, isAddAwaitStoreLoading, isStore, isAwaitStore, isLoading, bujianStoreRef, awaitStoreRef, paibanData, needToAwaitPlanks, selectIds, timer, awaitStoreFilterTime, bujianStoreFilterTime, filterTime, search, selectOption, t, ct, handleBatchDelete, handleSinglePushAwaitStore, handleSearch, handleBatchAddBujianToAwaitStore, addPlankToAwaitStore, bujianRecordKeys, savePushToAwaitStoreRecord, handleStartLoading, handleBatchPaiban, handleOk, handlePushPlankToAwaitStore, handleTabChange, handlePlankSelectChange, handleTimeChange, LibraryType, GBaseModal, GBujianTable, store, translate, pickerOptions, searchTypeList }
}

})